import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SmashSwiperComponent } from './smash-swiper.component';
import { SmashImageModule } from '../smash-image/smash-image.module';
import { SharedModule } from '@app/shared/shared.module';
import { SmashPlayerComponent } from '@app/shared/components/smash-player/smash-player.component';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    SmashImageModule,
    SmashPlayerComponent,
    SharedModule,
    SmashSwiperComponent,
  ],
  providers: [],
  exports: [
    SmashSwiperComponent,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]

})
export class SmashSwiperModule { }

